import React from 'react';
import Banner from '../components/banner';
import KeyFeatures from '../components/key-features';
import LoanCalculator from '../components/loan-calculator';
import LoanStep from '../components/loan-step';
import EligibilityCriteria from '../components/EligibilityCriteria';
import RequiredDocuments from '../components/RequiredDocuments';
import AboutPointBanner from '../components/about-point-banner';

const Home = () => {
  return (
    <>
      <Banner />
      <div className="home-sections">
        <KeyFeatures />
        <LoanCalculator />
        <LoanStep />
        <EligibilityCriteria />
        <RequiredDocuments />
        <AboutPointBanner />
      </div>
    </>
  );
};

export default Home;
